export const WARNING_CONFIDENCE_THRESHOLD = process.env
    .REACT_APP_INITIAL_CONFIDENCE
    ? parseFloat(process.env.REACT_APP_INITIAL_CONFIDENCE)
    : 1.0;
